import { Vestiging } from "@/entities/vestiging";
import { createColumnHelper } from "@tanstack/react-table";
import { NameCol, OpeningHoursCol } from "../../shared";
import type { FaciliteitenTableFeatures } from "../../shared/faciliteiten-table-features";
import { BadgeCol, Handlers, MenuCol } from "./columns";

export const createColumns = (handlers: Handlers) => {
    const columnHelper = createColumnHelper<FaciliteitenTableFeatures, Vestiging>();
    return columnHelper.columns([
        columnHelper.accessor("beheerVestiging.vestigingNaam", {
            cell: ({ row }) => <NameCol variant="bestaandeAanvraagRegievoerder" vestiging={row.original} />,
        }),
        columnHelper.accessor("aangevraagdeVestiging.openingstijden", {
            cell: ({ row }) => <OpeningHoursCol vestiging={row.original} />,
        }),
        columnHelper.display({
            id: "badge",
            cell: ({ row }) => <BadgeCol vestiging={row.original} />,
        }),
        columnHelper.display({
            id: "menu",
            cell: ({ row }) => {
                const vestiging = row.original;
                if (!Vestiging.canModifyOpeningHours(vestiging, "bestaandeAanvraag") && !Vestiging.canRequestStop(vestiging)) {
                    return null;
                }
                return (
                    <MenuCol
                        vestiging={vestiging}
                        onStopRequest={handlers.onStopRequest}
                        onUpdateOpeningstijd={handlers.onUpdateOpeningstijd}
                    />
                );
            },
        }),
    ]);
};
